import { useEffect, useState } from "react";
import { History as HIcon } from "lucide-react";
import { Badge, DNS_LABEL, SSL_LABEL, fmt } from "./util";

export function History({ api, pid, stamp }) {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { if (open) { api.get(`/projects/${pid}/domain/history`).then((r) => setRows(r.data)).catch(() => setRows([])); } }, [open, api, pid, stamp]);
  return (
    <details className="rounded-xl border border-slate-200 p-3" onToggle={(e) => setOpen(e.currentTarget.open)} data-testid="domain-history">
      <summary className="cursor-pointer font-semibold text-[#062a20] text-sm inline-flex items-center gap-1.5"><HIcon className="w-4 h-4" />Verification history</summary>
      {rows === null ? <p className="text-xs text-slate-500 mt-2">Loading…</p> : !rows.length ? <p className="text-xs text-slate-500 mt-2">No checks yet.</p> :
        <ul className="mt-2 divide-y text-xs">{rows.map((h) => (
          <li key={h.at} className="py-1.5 flex flex-wrap items-center gap-2" data-testid="domain-history-row">
            <span className="text-slate-500 w-36">{fmt(h.at)}</span>
            <Badge map={DNS_LABEL} value={h.dns_status} /><span>SSL:</span><Badge map={SSL_LABEL} value={h.ssl_status} />
            <span className="text-slate-500">HTTPS {h.https_ok ? "working" : "not yet"} · {h.trigger.replace("_", " ")}</span>
          </li>))}</ul>}
    </details>);
}
